"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var styles = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const StyledIcon = /*#__PURE__*/_styledComponents.default.svg.withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "bufferapp-ui__sc-dbjb4v-0"
})(["", ";", ";vertical-align:", ";"], styles.base, props => styles[props.size], props => props.verticalAlign ? props.verticalAlign : 'unset');
const Icon = _a => {
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  return /*#__PURE__*/_react.default.createElement(StyledIcon, Object.assign({}, props), /*#__PURE__*/_react.default.createElement("title", null, props.title), children);
};
Icon.propTypes = {
  size: _propTypes.default.oneOf(['small', 'smedium', 'medium', 'large', 'extraLarge']),
  verticalAlign: _propTypes.default.string,
  title: _propTypes.default.string
};
Icon.defaultProps = {
  size: 'medium',
  verticalAlign: '',
  title: ''
};
var _default = exports.default = Icon;